import React from 'react';
import { graphql } from 'gatsby';
import SupportArticle from '../../components/help-center/SupportArticle';
import Layout from '../../components/Layout';
import LayoutSection from '../../components/layout-section/LayoutSection';
import SEO from '../../components/Seo';
import useSystemPages from '../../hooks/useSystemPages';
import { ArticlePageProps } from '../../types/helpCenter/helpCenter';

// TODO AS-472 : remove the existence of relatedContent & relatedPages
export const query = graphql`
query ($locale: String!, $tags: [String], $contentful_id: String!) {
  pageContent: contentfulSupportArticlePage(
    contentful_id: { eq: $contentful_id },
    node_locale: { eq: $locale }
  ) {
    contentful_id
    title
    seoTitle
    slug
    heroImage {
      url
      title
      width
      height
    }
    gallery {
      images {
        title
        url
        width
        height
      }
      enlargedImages: images {
        title
        url
        width
        height
      }
      thumbnails: images {
        title
        url
      }
    }
    summary {
      summary
    }
    content {
      content
    }
    category {
      path
      title
    }
    linkedFaq {
      ...LinkedFaq
    }
    linkedSupportArticles {
      title
      path
      featuredImage {
        url
        width
        height
        title
      }
      featuredDescription {
        featuredDescription
      }
    }
    seoDescription {
      seoDescription
    }
    seoRobots {
      seoRobots
    }
    openGraphImage {
      ...OpenGraphImage
    }
    pageBuilder
  }
  relatedPages: allContentfulSupportArticlePage(filter: {
    tags: {in: $tags}, contentful_id: {ne: $contentful_id}, node_locale: {eq: $locale}}) {
    edges {
      node {
        title
        path
        featuredImage {
          title
          url
          width
          height
        }
        featuredDescription {
          featuredDescription
        }
      }
    }
  }
  relatedContent: allContentfulSupportFaq(filter: {
    tags: {in: $tags}, node_locale: {eq: $locale}}) {
    edges {
      node {
        id
        title
        content {
          content
        }
      }
    }
  }
}`;

const ArticlePage = ({ data, pageContext }: ArticlePageProps) => {
  const { pageContent, relatedPages, relatedContent } = data;
  const [helpCenterIndex] = useSystemPages('helpCenterIndex');

  return (
    <Layout localizedPaths={pageContext.localizedPaths}>
      <LayoutSection withSidebar={false} withDivider={false}>
        <SupportArticle
          dashboardUrl={helpCenterIndex.path}
          article={pageContent}
          relatedPages={relatedPages}
          relatedContent={relatedContent}
        />
      </LayoutSection>
    </Layout>
  );
};

export const Head = ({ data, pageContext }: ArticlePageProps) => {
  const content = data.pageContent;
  return (
    <SEO
      locale={pageContext.locale}
      title={content.seoTitle}
      description={content.seoDescription?.seoDescription}
      robots={content.seoRobots?.seoRobots}
      alternates={pageContext.alternates}
      image={content.openGraphImage?.url}
    />
  );
};

export default ArticlePage;
